var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "z-depth-1 header-row" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 col-sm-3 mb-2 ml-3" }, [
            _c(
              "a",
              { staticClass: "header-logo", attrs: { href: "/savings" } },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    "data-testid": "header-image",
                    src: _vm.headerLogoSrc,
                    alt: _vm.headerLogoAlt
                  }
                })
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container mb-1" }, [
      _c("div", { staticClass: "row hero-row" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6 text-center" }, [
          _c(
            "p",
            {
              staticClass: "hero-headline",
              attrs: { "data-testid": "landingPage-heading" }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.leadChannelHeadLine) +
                  " to bring you a "
              ),
              _c("strong", [_vm._v("better")]),
              _vm._v(" car payment.\n        ")
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "hero-subheadline" }, [
            _vm._v(
              "\n          Last year we saved our drivers an average of $1,260.\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "d-xs-block d-sm-none hero-subheadline2" }, [
            _vm._v(
              "\n          Ready to see how much you could save?\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-apply-now",
              attrs: { href: "/", "data-testid": "apply-now-button" }
            },
            [_vm._v("Apply Now")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6 text-center p-0 px-sm-3" },
          [
            _c("img", {
              staticClass: "img-fluid d-none d-sm-block",
              attrs: { src: _vm.images.desktopdog }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-fluid d-xs-block d-sm-none",
              staticStyle: { "margin-bottom": "-6px" },
              attrs: { src: _vm.images.refidoautorefinanceredcar }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-center review-row mb-4" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.testimonialList, function(testimonial, $index) {
            return _c(
              "div",
              {
                key: $index,
                staticClass: "col-xs-12 col-sm-3",
                attrs: { "data-testid": "testimonial-" + $index }
              },
              [
                $index > 0
                  ? _c("div", { staticClass: "d-none d-sm-block" }, [
                      _c("i", { staticClass: "material-icons rating-stars" }, [
                        _vm._v(_vm._s(testimonial.rating))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v('"' + _vm._s(testimonial.quote) + '"')]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "-" +
                            _vm._s(testimonial.name) +
                            ", " +
                            _vm._s(testimonial.source)
                        )
                      ])
                    ])
                  : _c("div", [
                      _c("i", { staticClass: "material-icons rating-stars" }, [
                        _vm._v(_vm._s(testimonial.rating))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v('"' + _vm._s(testimonial.quote) + '"')]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "-" +
                            _vm._s(testimonial.name) +
                            ", " +
                            _vm._s(testimonial.source)
                        )
                      ])
                    ])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "p",
        {
          staticClass: "text-center font-weight-bold mt-125em connect-with-us"
        },
        [_vm._v("\n      Connect with us\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row text-center contact-row" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass: "card-panel hoverable contact-panel",
              attrs: { id: "contact-call" }
            },
            [
              _c(
                "div",
                { staticClass: "mb-2" },
                [_c("CallSvg", { staticClass: "svg-icon" })],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "tel:" + _vm.leadChannelPhoneNumber,
                      "data-testid": "phone-number-link"
                    }
                  },
                  [_vm._v(_vm._s(_vm.leadChannelPhoneNumber))]
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Mon. - Fri. 7 am - 7 pm MDT")]),
              _vm._v(" "),
              _c("p", [_vm._v("Sat. 9 am - 5 pm MDT")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass: "card-panel hoverable contact-panel",
              attrs: { id: "contact-live-chat" }
            },
            [
              _c(
                "div",
                { staticClass: "mb-2" },
                [_c("ChatSvg", { staticClass: "svg-icon" })],
                1
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", [_vm._v("Mon. - Sat. 9 am - 5 pm MDT")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass: "card-panel hoverable contact-panel",
              attrs: { id: "contact-schedule" }
            },
            [
              _c(
                "div",
                { staticClass: "mb-2" },
                [_c("EmailSvg", { staticClass: "svg-icon" })],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:" + _vm.leadChannelEmailAddress,
                      "data-testid": "email-us-link"
                    }
                  },
                  [_vm._v("Email Us")]
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Have questions?")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "applypage-footer text-center" }, [
      _c("div", { staticClass: "container container-xl" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("img", {
              staticClass: "img-fluid mb-2 border-0",
              attrs: {
                src:
                  "https://seal-austin.bbb.org/seals/gray-seal-250-52-whitetxt-bbb-48392.png",
                "data-testid": "BBB-image",
                alt: _vm.leadChannelBrand + " BBB Business Review"
              }
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "bottom-links" }, [
              _c("li", { attrs: { "data-testid": "footer-copyright" } }, [
                _vm._v(
                  "\n              © " +
                    _vm._s(new Date().getFullYear()) +
                    " POWERED BY " +
                    _vm._s(_vm.leadChannelBrand) +
                    " LLC. All rights reserved.\n            "
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "container reasons-container" }, [
        _c("p", { staticClass: "text-center reasons-to-refinance" }, [
          _vm._v("\n        Reasons to Refinance Your Car\n      ")
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("Reduce your monthly payments:")]),
            _vm._v(
              " Refinancing your\n          auto loan may reduce your monthly payments by lowering your interest\n          rate and/or extending your loan term.\n        "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _vm._v(
                "Reduce the total amount of interest you pay on your car\n            loan:"
              )
            ]),
            _vm._v(
              " Refinancing your auto loan to a lower interest\n          rate and/or a shorter term may reduce the total amount of\n          interest you pay.\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/", "data-testid": "apply-now-link" } }, [
          _vm._v("Apply now to refinance your car")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("a", { attrs: { role: "button", "data-testid": "live-chat-link" } }, [
        _vm._v("Live Chat")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }